<template>
  <div>
    <div v-if="isMobile">
      <app-history
        v-for="index in history.length"
        :key="index"
        :index="index - 1"
        :item="history[index - 1]"
        :selectedItem="selectedItem"
        @clicked="onClickItem"
        @removeRequest="removeRequest"
        @callDownload="callDownloadFromCard"
        >.
      </app-history>
    </div>
    <div v-else>
      <v-data-table
        :items="history"
        item-key="Fserial"
        :headers="historyHeaders"
        class="elevation-1 rounded"
        :disable-pagination="true"
        :hide-default-footer="true"
        :no-data-text="tableText"
        show-expand
      >
        <template v-slot:[`item.Removeable`]="{ item }">
          <v-btn
            class="grid"
            v-if="item.Removeable"
            color="red white--text"
            rounded
            @click="removeRequest(item.Fserial)"
          >
            حذف درخواست
          </v-btn>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <br />
            <b>نوع تحصیل: </b>
            <span v-html="item.Hozoori"></span>

            <br />
            <br />
            <b>تاریخ درخواست: </b>
            <span v-html="item.DDate"></span>

            <br />
            <br />
            <b>تاریخ شروع: </b>
            <span v-html="item.D_Start"></span>

            <br />
            <br />
            <b>استان: </b>
            <span v-html="item.OstanName"></span>

            <br />
            <br />
            <b>رشته: </b>
            <span v-html="item.N_Field"></span>

            <br />
            <br />

            <b>توضیحات طلبه: </b>
            <span v-html="item.StudentComment"></span>

            <br />
            <br />
            <b>نظر آموزش: </b>{{ item.AmoozeshState }}.
            <span v-html="item.AmoozeshComment"></span>
            <br />
            <br />
            <b>نظر حراست: </b>{{ item.TahghighatState }}.
            <span v-html="item.TahghighatComment"></span>
            <br />
            <br />
          </td>
        </template>
      </v-data-table>
    </div>
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import History from "./History";
import Dialog from "@/components/Dialog";
import { removeTahsilRequest, getHistory } from "@/api/tahsil";
import { saveByteArray } from "@/utils/constants";
export default {
  components: {
    appHistory: History,
    appDialog: Dialog,
  },
  data() {
    return {
      selectedItem: -1,
      history: [],
      historyHeaders: [
        {
          text: "وضعیت",
          value: "StrState",
          width: "15%",
        },
        {
          text: "شناسه درخواست",
          value: "Fserial",
          width: "10%",
        },

        {
          text: "شهر",
          value: "ShahrestanName",
          width: "15%",
        },
        {
          text: "نام موسسه",
          value: "N_Location",
          width: "15%",
        },

        {
          text: "",
          value: "Removeable",
          width: "5%",
          sortable: false,
        },

        { text: "جزییات", value: "data-table-expand", width: "5%" },
      ],
    };
  },
  created() {
    this.geTahsilHistory();
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },
  methods: {
    /**
     * expand khorooj
     */
    geTahsilHistory() {
      this.$store.commit("SET_TABLE_TEXT", true);
      return new Promise((resolve, reject) => {
        getHistory()
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.history = response.data;

            this.$store.commit("SET_TABLE_TEXT", false);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    onClickItem(index) {
      if (this.selectedItem != index) {
        this.selectedItem = index;
      } else {
        this.selectedItem = -1;
      }
    },
    /**
     * show confirm dialog
     */
    removeRequest(index) {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", index);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این درخواست هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },
    /**
     * call remove api if user click on yes
     */
    onCloseDialog(index) {
      if (index != -1) {
        removeTahsilRequest(index)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);

            if (data.Success) {
              this.geTahsilHistory();
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
  },
};
</script>
<style scoped>
.grid {
  margin: 10px 0;
}
</style>
